import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { doGetUser } from "services/user/user";
import { loginListUserSignicat } from "stores/actions/auth";

const UserInvitationSignicatSuccessView = () => {
  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get("accessToken");
  const refreshToken = searchParams.get("refreshToken");
  const navigate = useNavigate();

  useEffect(() => {
    const execute = async () => {
      if (accessToken && refreshToken) {
        // make signicat login and redirect to dashboard
        await loginListUserSignicat(accessToken, refreshToken);

        // get user
        const user = await doGetUser();

        // redirect to the correct place
        navigate(`/user/list/${user.list_uuid}`);
      }
    };
    execute();
  }, [accessToken, refreshToken]);

  return null;
};

export default UserInvitationSignicatSuccessView;
